import { IFloorplanViewModel } from "../../components/floorplan/interface";

function data(): IFloorplanViewModel {
    return {
        backgroundColor: 'transparent',
        title: {
            text: '',
            fontFamily: 'Gill Sans',
            fontSize: '10vmin',
            fontAlignment: "center",
            fontWeight: 500,
            color: 'transparent',
            visible: false,
        },
        imageUrl: '',
        startX: 0,
        startY: 0,
        maxZoom: 0,
        minZoom: 1,
        startZoom: 1,
    
        items: [],

        backButton: {
            backgroundColor: 'transparent',
            strokeColor: 'transparent',
            strokeSize: 0,
            arrowColor: 'transparent',
        },
    
        onBack: ()=>{},
    }
}

export default data;
